<template>
  <div>
    <PreviewLayout :item="item" :loading="loading">
      <div class="p-characterItem">
        <div
          v-if="item.itemableAttributes.imageSide === 'right'"
          class="p-characterItem__rightBalloon"
        >
          <div class="p-characterItem__rightBalloon__content">
            <span
              class="p-characterItem__contentBody"
              v-html="previewContent(content)"
            ></span>
          </div>
        </div>
        <div class="p-characterItem__avatar">
          <v-avatar size="72">
            <img
              v-if="item.itemableAttributes.characterImage"
              :src="item.itemableAttributes.characterImage.avatar.thumb.url"
            />
          </v-avatar>
          <div v-if="item.itemableAttributes.characterImage" class="mt-1">
            {{ item.itemableAttributes.characterImage.name }}
          </div>
        </div>
        <div
          v-if="item.itemableAttributes.imageSide === 'left'"
          class="p-characterItem__leftBalloon"
        >
          <div class="p-characterItem__leftBalloon__content">
            <span
              class="p-characterItem__contentBody"
              v-html="previewContent(content)"
            ></span>
          </div>
        </div>
      </div>

      <div class="html-content"></div>
    </PreviewLayout>
  </div>
</template>

<script>
import PreviewLayout from './PreviewLayout'
import baseTextlintPreview from '@/mixins/base_textlint_preview'

export default {
  name: 'CharacterItemPreview',
  components: { PreviewLayout },
  mixins: [baseTextlintPreview],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    content: function () {
      return this.item.itemableAttributes.content
    }
  },
  mounted () {
    this.setLintAction(this.content)

    this.$store.subscribe((mutation) => {
      if (mutation.type === 'PostEditor/UPDATE_ITEM') {
        if (mutation.payload.uuid === this.item.uuid) {
          this.setLintAction(this.content)
          this.$store.commit('TextLintStore/deleteItemLintResult', {
            uuid: this.uuid
          })
          this.lintAction().call()
        }
      }
    })
  }
}
</script>

<style scoped lang="sass">
.p-characterItem
  display: flex
  &__contentBody
    white-space: pre-line
    word-wrap: break-word
  &__avatar
    width: 120px
    text-align: center
  &__leftBalloon
    padding: 10px 0
    &__content
      display: inline-block
      position: relative
      margin-left: 5px
      padding: 17px 13px
      border-radius: 12px
      background: #e8e8e8
      min-width: 400px
      &:after
        content: ""
        display: inline-block
        position: absolute
        top: 18px
        left: -24px
        border: 12px solid transparent
        border-right: 12px solid #e8e8e8
  &__rightBalloon
    padding: 10px 0
    &__content
      display: inline-block
      position: relative
      margin-right: 5px
      padding: 17px 13px
      border-radius: 12px
      background: #e8e8e8
      min-width: 400px
      &:after
        content: ""
        display: inline-block
        position: absolute
        top: 18px
        right: -24px
        border: 12px solid transparent
        border-right: 12px solid #e8e8e8
        -webkit-transform: rotate(-180deg)
        transform: rotate(-180deg)
</style>
